import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const configurationTabEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-configuration-tab" */ './ConfigurationPanel.tsx'),
	),
	getPreloadProps: () => ({
		extraProps: {},
	}),
});
